import { cx } from '@/utils/strings'
import ThumbsUpIcon from '@/icons/bwi/thumbs-up.svg'

type FeedbackButtonsProps = {
  color?: 'black' | 'white'
  onFeedback?: (feedback: 'up' | 'down') => void
}

export default function FeedbackButtons({ onFeedback, color = 'black' }: FeedbackButtonsProps) {
  return (
    <div className="flex justify-center gap-2">
      <button
        onClick={() => onFeedback?.('up')}
        className={cx(
          color === 'black' && 'text-secondary-800',
          color === 'white' && 'text-white',
          'hover:text-primaryBlue dark:text-white transition-colors p-2 focus:outline-none focus:shadow-outline'
        )}
      >
        <ThumbsUpIcon className="w-4 h-4" />
      </button>
      <button
        onClick={() => onFeedback?.('down')}
        className={cx(
          color === 'black' && 'text-secondary-800',
          color === 'white' && 'text-white',
          'hover:text-red-600 dark:text-white transition-colors p-2 focus:outline-none focus:shadow-outline'
        )}
      >
        <ThumbsUpIcon className="w-4 h-4 rotate-180" />
      </button>
    </div>
  )
}
